module.exports = __webpack_public_path__ + "img/forest.56d921ca.svg";